import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import TopBar from './components/TopBar/TopBar';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import BestSellers from './components/BestSellers/BestSellers';
import ClassicFashion from './components/ClassicFashion/ClassicFashion';
import BlogSection from './components/BlogSection/BlogSection';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import Footer from './components/Footer/Footer';
import PopupNewsletter from './components/PopupNewsletter/PopupNewsletter';
import RecentPurchases from './components/RecentPurchases/RecentPurchases';
import ProductDetail from './components/ProductDetail/ProductDetail';
import Checkout from './components/Checkout/Checkout';
import BlogDetail from './components/BlogDetail/BlogDetail';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import CartDrawer from './components/CartDrawer/CartDrawer';
import './App.css';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <BestSellers />
      <ClassicFashion />
      <BlogSection />
      <FeaturesSection />
    </>
  );
};

const App: React.FC = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  return (
    <CartProvider>
      <div className="App">
        <ScrollToTop />
        <TopBar />
        <Header onCartClick={() => setIsCartOpen(true)} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product/:slug" element={<ProductDetail onAddToCart={() => setIsCartOpen(true)} />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
        </Routes>
        <Footer />
        <PopupNewsletter />
        <RecentPurchases />
        <CartDrawer isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      </div>
    </CartProvider>
  );
};

export default App;

